import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';


class ScheduleGradeAircraftLineBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      sga_id: this.props.sga_id,
      bases_list: this.props.bases_active_list,
      base_name: this.props.base_name,
      base_id: this.props.base_id,
      edit_mode: this.props.edit_mode,
      show_select: 0,
      modal: false,
    };

    this.locale = getLocale();

    this.toggleSelect = this.toggleSelect.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.base_id !== 'undefined' && typeof newProps.base_name !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      if(newProps.base_name === null) {
        this.setState({base_name: 'BAS.'});
      } else {
        this.setState({base_name: newProps.base_name});
      }
      if(newProps.base_id === 0) {
        this.setState({base_id: null});
        this.setState({base_name: 'BAS.'});
      } else {
        this.setState({base_id: newProps.base_id});
      }
      this.setState({
        sga_id: newProps.sga_id,
        bases_list: newProps.bases_active_list,
        loaded: 1,
        show_select: 0,
        modal: false,
      });
    }
    this.setState({edit_mode: newProps.edit_mode});

  }
  
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = this.state.base_id;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
    if (event !== null && this.state.show_select) {
      this.props.changeBaseId(event.value, this.state.sga_id);
    }
  } 

  // exibe o select
  toggleSelect() {
    if(this.state.edit_mode) {
      this.setState({show_select: 1});
    }
  }

  // Fecha select quando pressionada a tecla esc
  escFunction(event){
    if(event.keyCode === 27) {
      this.setState({show_select: 0});
    }
  }

  // Fecha modal
  closeModal(event){
    this.setState({modal: false});
  }

  render() {
    var self = this;
    return (
  <div className="text-center" onClick={this.toggleSelect}>
    <RequestApi ref={'request_api'} handleLoaded={this.props.handleLoaded} />

    {(self.state.show_select === 0) ? 
      <div>{self.state.base_name}</div>
    :
      <Select
        className="form-field-name"
        name="base_id"
        value={self.state.base_id}
        searchable={true}
        placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tabelaPrincipal.placeholder.BAS}
        onChange={self.handleSelectChange.bind(self, 'base_id')}
        options={self.state.bases_list}
        menuPortalTarget={document.body}
        menuPosition={'fixed'}
        styles={{
          // Fixes the overlapping problem of the component
          menuPortal: provided => ({ ...provided, zIndex: 9999 }),
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />    
    }
  </div>
    );
  }
}

export default ScheduleGradeAircraftLineBase;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeAircraftLineBase.js